/* eslint-disable-next-line import/prefer-default-export */
export const GRAVATAR_URL = 'https://www.gravatar.com/avatar';
